import { useSuspenseQuery } from "@apollo/client/react";

import { GetTenantDocument, type GetTenantQuery, type GetTenantQueryVariables } from "~/features/admin/tenants/gqls";

/** Tenant detail with members and audit timestamps. */
export function useTenantDetail(id: string) {
  return useSuspenseQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, {
    variables: { id },
  });
}
